// extracted by mini-css-extract-plugin
export var alternate = "_q-j";
export var black = "_q-6";
export var blue = "_q-f";
export var blueLight = "_q-e";
export var brand = "_q-8";
export var darkMode = "_q-b";
export var error = "_q-a";
export var gray = "_q-5";
export var grayBlue = "_q-d";
export var iconWrapper = "_q-3";
export var inactive = "_q-7";
export var indigo = "_q-g";
export var orange = "_q-i";
export var pink = "_q-h";
export var primary = "_q-0";
export var purple = "_q-9";
export var success = "_q-4";
export var warning = "_q-c";
export var white = "_q-1";
export var whiteSuccess = "_q-2";